function invalid(key) {
  const error = new Error(key);
  error.error_key = key;
  return error;
}

export default async function prepareChatImage(file) {
  const type = file.type || ({ jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png",
    gif: "image/gif", webp: "image/webp", bmp: "image/bmp" }[file.name.split(".").pop().toLowerCase()]);
  if (!file.size) throw invalid("chat.imageUnreadable");
  if (!/^(image\/(jpeg|png|gif|webp|bmp))$/.test(type || "")) throw invalid("chat.unsupportedImage");
  if (file.size > 30 * 1024 * 1024) throw invalid("chat.imageTooLarge");
  const url = URL.createObjectURL(file);
  let timer;
  try {
    const image = await new Promise((resolve, reject) => {
      const picture = new Image();
      timer = setTimeout(() => reject(invalid("chat.imageUnreadable")), 15000);
      picture.onload = () => { clearTimeout(timer); resolve(picture); };
      picture.onerror = () => { clearTimeout(timer); reject(invalid("chat.imageUnreadable")); };
      picture.src = url;
    });
    const width = image.naturalWidth, height = image.naturalHeight;
    if (!width || !height) throw invalid("chat.imageUnreadable");
    if (type === "image/gif") {
      if (file.size > 5 * 1024 * 1024 || width > 8192 || height > 8192 || width * height > 16777216) {
        throw invalid("chat.imageTooLarge");
      }
      return file;
    }
    if (["image/jpeg", "image/png"].includes(type) && file.size <= 1024 * 1024 && Math.max(width, height) <= 1600) {
      return file;
    }
    const ratio = Math.min(1, 1600 / Math.max(width, height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * ratio));
    canvas.height = Math.max(1, Math.round(height * ratio));
    const context = canvas.getContext("2d");
    if (!context) throw invalid("chat.imageUnreadable");
    context.fillStyle = "#fff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", 0.85));
    if (!blob || !blob.size || blob.size > 5 * 1024 * 1024) throw invalid("chat.imageTooLarge");
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } finally {
    clearTimeout(timer);
    URL.revokeObjectURL(url);
  }
}
